import React from 'react';
import Button from './Button';

interface PopupPropsBase {
  hideTopBlur?: boolean;
  onClose: () => void;
}

type PopupProps = PopupPropsBase & React.HTMLProps<HTMLDivElement>;

function Popup(props: PopupProps) {
  const { children, onClose, ...rest } = props;

  function handleInnerClick(event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  return (
    <>
      {!props.hideTopBlur && (
        <Button
          outline="border-black"
          shape="circle"
          size={20}
          className="text-3xl text-white bg-black popup-close"
          icon={['far', 'xmark']}
          onClick={onClose}
          style={{ zIndex: 22 }}
        />
      )}
      <div
        {...rest}
        className="blur-container backdrop-blur fixed w-full left-0 overflow-y-auto pb-8"
        onClick={onClose}
        style={{
          top: props.hideTopBlur ? 77 : 0,
          height: `calc(100% - ${props.hideTopBlur ? 77 : 0}px)`,
          zIndex: 20,
        }}
      >
        {!props.hideTopBlur && (
          <div
            className="w-full"
            onClick={onClose}
            style={{
              height: 77,
            }}
          ></div>
        )}
        <div className="relative" onClick={handleInnerClick}>
          {children}
        </div>
      </div>
    </>
  );
}

export default Popup;
